module.exports = __webpack_public_path__ + "img/Earth.4faca846.png";